// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2b3gZ","detailsBorder":"styles_detailsBorder__C2JNz"};